import React from "react";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

const variants = {
  primary:   "bg-brand-600 hover:bg-brand-700 text-white shadow-sm hover:shadow-md",
  secondary: "bg-white hover:bg-slate-50 text-brand-600 border border-brand-200 hover:border-brand-300 shadow-sm",
  danger:    "bg-heart-600 hover:bg-red-700 text-white shadow-sm",
  ghost:     "bg-transparent hover:bg-slate-100 text-slate-600 dark:hover:bg-slate-800 dark:text-slate-300",
  outline:   "bg-transparent border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800",
};

const sizes = {
  sm:  "h-8  px-3  text-xs  gap-1.5 rounded-lg",
  md:  "h-10 px-4  text-sm  gap-2   rounded-xl",
  lg:  "h-12 px-6  text-sm  gap-2   rounded-xl",
  xl:  "h-14 px-8  text-base gap-2  rounded-2xl",
};

export default function Button({
  children,
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,
  fullWidth = false,
  icon,
  className = "",
  ...props
}) {
  const base =
    "inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed select-none";

  return (
    <motion.button
      whileTap={{ scale: disabled || loading ? 1 : 0.97 }}
      className={`${base} ${variants[variant]} ${sizes[size]} ${fullWidth ? "w-full" : ""} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <Loader2 size={16} className="animate-spin" />
      ) : icon ? (
        <span className="shrink-0">{icon}</span>
      ) : null}
      {children}
    </motion.button>
  );
}
